import { Driver } from "@types";

export const sortDrivers = (drivers: Driver[], selectedId?: string): Driver[] => {
    return [...drivers].sort((a, b) => {
        if (a.id === selectedId) return -1;
        if (b.id === selectedId) return 1;
        return a.name?.localeCompare(b.name || "") || 0;
    });
};

export const sortStr = (arr: string[]) => {
    return arr.sort((a, b) => a.localeCompare(b))
}